import { SB } from '@play-co/replicant';

export const match3Schema = () => {
  const blockSchema = SB.tuple(['d', 'f', 't', 'p', 'c', 'g']);
  const matchSchema = SB.object({
    type: blockSchema,
    count: SB.number(),
  });

  const match3Schema = SB.object({
    // Board state is a 2D array, starting with the bottom tile of the right-most column
    board: SB.array(SB.array(blockSchema)),

    currentMatchIndex: SB.number().optional(),

    turns: SB.array(
      SB.object({
        matches: SB.array(matchSchema),
        rewards: SB.object({
          points: SB.number().min(0),
          gems: SB.number().min(0),
        }),
      }),
    ),
  });

  return {
    match3: match3Schema.optional(),
  };
};
